import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    usuario: '',
    //Permisos relacionados al emisor
    alPermisosEmisor: false,
    listarEmisor: false,
    modificarEmisor: false,
    agregarCertificadoEmisor: false,
    eliminarCertificadoEmisor: false,
    actualizarImagenKudeEmisor: false,
    listarTimbradoEmisor: false,
    modificarTimbradoEmisor: false,
    //Permisos relacionados al usuario
    allPermisosUsuario: false,
    crearUsuario: false,
    listarUsuarios: false,
    editarUsuarios: false,
    cambiarEstadoUsuario: false,
    cambiarClaveUsuario: false,
    //Permisos relacionados con los documentos electrónicos
    allPermisosDE: false,
    listarDE: false,
    verDetalleDE: false,
    crearDE: false,
    editarDE: false,
    eventoNominacionDE: false,
    eventoRecepcionDE: false,
    eventoConformidadDE: false,
    eventoDisconformidadDE: false,
    eventoDesconocimientoDE: false,
    eventoInutilizacionDE: false,
    eventoCancelacionDE: false,
    descargarKude: false,
    descargarXML: false,
    visorXML: false,
    enviarCorreoDE: false,
    verEventosCorreosDE: false,
    //Permisos relacionados con los reportes
    allPermisosReportes: false,
    reporteVentas: false,
    asignaciones: {},
    emisorSeleccionado: {}
};

export const usuarioReducer = createSlice({
    name: 'usuario',
    initialState: initialState,
    reducers: {
        setAllPermisosEmisor: (state, action) => {
            state.allPermisosEmisor = action.payload;
        },
        setListarEmisor: (state, action) => {
            state.listarEmisor = action.payload;
        },
        setModificarEmisor: (state, action) => {
            state.modificarEmisor = action.payload;
        },
        setAgregarCertificadoEmisor: (state, action) => {
            state.agregarCertificadoEmisor = action.payload;
        },
        setEliminarCertificadoEmisor: (state, action) => {
            state.eliminarCertificadoEmisor = action.payload;
        },
        setActualizarImagenKudeEmisor: (state, action) => {
            state.actualizarImagenKudeEmisor = action.payload;
        },
        setListarTimbradoEmisor: (state, action) => {
            state.listarTimbradoEmisor = action.payload;
        },
        setModificarTimbradoEmisor: (state, action) => {
            state.modificarTimbradoEmisor = action.payload;
        },
        setAllPermisosUsuario: (state, action) => {
            state.allPermisosUsuario = action.payload;
        },
        setListarUsuarios: (state, action) => {
            state.listarUsuarios = action.payload;
        },
        setCrearUsuario: (state, action) => {
            state.crearUsuario = action.payload;
        },
        setEditarUsuario: (state, action) => {
            state.editarUsuarios = action.payload;
        },
        setCambiarEstadoUsuario: (state, action) => {
            state.cambiarEstadoUsuario = action.payload;
        },
        setCambiarClaveUsuario: (state, action) => {
            state.cambiarClaveUsuario = action.payload;
        },
        setAllPermisosDE: (state, action) => {
            state.allPermisosDE = action.payload;
        },
        setListarDE: (state, action) => {
            state.listarDE = action.payload;
        },
        setVerDetalleDE: (state, action) => {
            state.verDetalleDE = action.payload;
        },
        setCrearDE: (state, action) => {
            state.crearDE = action.payload;
        },
        setEditarDE: (state, action) => {
            state.editarDE = action.payload;
        },
        setEventoNominacionDE: (state, action) => {
            state.eventoNominacionDE = action.payload;
        },
        setEventoRecepcionDE: (state, action) => {
            state.eventoRecepcionDE = action.payload;
        },
        setEventoConformidadDE: (state, action) => {
            state.eventoConformidadDE = action.payload;
        },
        setEventoDisconformidadDE: (state, action) => {
            state.eventoDisconformidadDE = action.payload;
        },
        setEventoDesconocimientoDE: (state, action) => {
            state.eventoDesconocimientoDE = action.payload;
        },
        setEventoInutilizacionDE: (state, action) => {
            state.eventoInutilizacionDE = action.payload;
        },
        setEventoCancelacionDE: (state, action) => {
            state.eventoCancelacionDE = action.payload;
        },
        setDescargarKude: (state, action) => {
            state.descargarKude = action.payload;
        },
        setDescargarXML: (state, action) => {
            state.descargarXML = action.payload;
        },
        setVisorXML: (state, action) => {
            state.visorXML = action.payload;
        },
        setEnviarCorreoDE: (state, action) => {
            state.enviarCorreoDE = action.payload;
        },
        setVerEventosCorreoDE: (state, action) => {
            state.verEventosCorreoDE = action.payload;
        },
        setAllPermisosReportes: (state, action) => {
            state.allPermisosReportes = action.payload;
        },
        setReporteVentas: (state, action) => {
            state.reporteVentas = action.payload;
        },
        setUsuario: (state, action) => {
            state.usuario = action.payload.usuario;
        },
        setAsignaciones: (state, action) => {
            state.asignaciones = action.payload.asignaciones;
        },
        seleccionarEmisor: (state, action) => {
            state.emisorSeleccionado = action.payload.emisorSeleccionado;
        },
        clearUserState: (state) => {
            return { ...initialState };
        }
    }
});

export const {
    setAllPermisosEmisor,
    setListarEmisor,
    setModificarEmisor,
    setAgregarCertificadoEmisor,
    setEliminarCertificadoEmisor,
    setActualizarImagenKudeEmisor,
    setListarTimbradoEmisor,
    setModificarTimbradoEmisor,
    setAllPermisosUsuario,
    setListarUsuarios,
    setCrearUsuario,
    setEditarUsuario,
    setCambiarEstadoUsuario,
    setCambiarClaveUsuario,
    setAllPermisosDE,
    setListarDE,
    setVerDetalleDE,
    setEditarDE,
    setCrearDE,
    setEventoNominacionDE,
    setEventoRecepcionDE,
    setEventoConformidadDE,
    setEventoDisconformidadDE,
    setEventoDesconocimientoDE,
    setEventoInutilizacionDE,
    setEventoCancelacionDE,
    setDescargarKude,
    setDescargarXML,
    setVisorXML,
    setEnviarCorreoDE,
    setVerEventosCorreoDE,
    setAllPermisosReportes,
    setReporteVentas,
    setUsuario,
    setAsignaciones,
    seleccionarEmisor,
    clearUserState
} = usuarioReducer.actions;
